import React from 'react';
import { useTranslation } from 'react-i18next';

const Modal = ({content, handleCloseModal, size}) => {
    const { i18n } = useTranslation();
    return (
        <>
            <div className="modal__wrapper modal__wrapper_active" onClick={() => handleCloseModal(null)}></div>
            <article className={`modal ${size ? `modal_${size}` : ''}`}>
                {content}
                {!size ?
                    <p onClick={() => handleCloseModal(false)} className="main__subtitle modal__close navigation-link">
                        {i18n.t('app.page.modal.close')}
                    </p>
                    :
                    null}
            </article>

        </>
    )
};

export default Modal;
